@import "../../../styles/variables";
@import "node_modules/@se/web-ui/styles/_se-variable";
:host {
  display: flex;
  flex-direction: column;
  width: 100%;

  &:not(.hidden-on-scroll) {
    margin-top: 0px;
    transition: margin-top 300ms;
  }

  &.hidden-on-scroll:not(.was-expanded) {
    margin-top: -100%;
    transition: margin-top 300ms;
  }

  &.fixed {
    position: fixed;
    left: 0;
    z-index: 10000;
    background-color: $se-white;
  }

  &.collapsed {
    height: 100%;
  }
}

.mb-filters-full-menu {
  display: none;
  background-color: $svs-white;
  height: 100%;
}

.count-button-wrapper {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 40px;
  padding: 16px;
  z-index: 99;
  background-color: $svs-white;
}

filters-reset,
result-button,
filters-tree-menu,
.mb-filters-full-menu {
  display: none;

  &.visible {
    display: flex;

    &.d-block {
      display: block;
    }
  }
}

filters-reset.disable-on-request {
  position: relative;
  &:before {
    content: "";
    display: block;
    z-index: 2;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
  }
}

// Additional header components styles
.search-tab__results-sorting {
  margin-bottom: 20px;
  width: 100%;
}

:host(.fixed) .search-tab__results-sorting {
  margin: 0 auto;
  width: 100%;
  z-index: 1000; // To do not be overlapped by the filters header
}
